import './qna.message.css';
import template from './qna.message.tpl.html';

export const qnamessage = {
    bindings: {
        item: '<',
        displayname: '<'
    },
    template
};
